import { Button, Card, Group, Text } from "@mantine/core";
import { ClipboardList, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { DocumentTypeAction } from "./WelcomeDashboard";

interface DocumentTypeActionCardProps {
  docType: DocumentTypeAction;
}

export function DocumentTypeActionCard({
  docType,
}: DocumentTypeActionCardProps) {
  const { t } = useTranslation();

  return (
    <Card p="md" withBorder>
      <Text fw={600} size="md" mb="sm">
        {docType.name}
      </Text>
      <Group grow gap="sm">
        <Button
          component="a"
          href={docType.createHref}
          leftSection={<Plus size={16} aria-hidden="true" />}
          variant="filled"
          size="sm"
          data-testid={`welcome-create-${docType.id}`}
        >
          {t("welcome.createRequest")}
        </Button>
        <Button
          component="a"
          href={docType.viewHref}
          leftSection={<ClipboardList size={16} aria-hidden="true" />}
          variant="light"
          size="sm"
          data-testid={`welcome-view-${docType.id}`}
        >
          {t("welcome.viewDocTypeRequests")}
        </Button>
      </Group>
    </Card>
  );
}
